module.exports = __webpack_public_path__ + "static/media/envelope-alt.cf6bed92.svg";